import React, { FC } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { PaymentButtonBox } from '../../styles/jss/components/review';

interface PaymentConfig {
  clientId?: string;
  currency?: string;
  button?: {
    color?: string;
    shape?: string;
    text?: string;
  };
  messages?: {
    paymentErrorMessage?: string;
  };
}

interface ComponentProps {
  app?: {
    payment?: {
      config?: PaymentConfig;
    };
  };
}

interface IPayPalProperties {
  componentProps: ComponentProps;
  amountToPay: number | string;
  handleShowErrorPage: (message: string, show: boolean) => void;
  handleSuccessPurchase: (transactionId?: string) => void;
}

const PayPal: FC<IPayPalProperties> = ({
  componentProps,
  amountToPay,
  handleShowErrorPage,
  handleSuccessPurchase,
}) => {
  const config = componentProps?.app?.payment?.config;
  const currency = componentProps?.app?.payment?.config?.currency ?? 'USD';

  const clientId = componentProps?.app?.payment?.config?.clientId ?? '';

  return (
    <PayPalScriptProvider options={{ clientId: clientId, currency }}>
      <PaymentButtonBox>
        <PayPalButtons
          style={{
            color: config?.button?.color as "gold" | "blue" | "silver" | "white" | "black" | undefined,
            shape: config?.button?.shape as "rect" | "pill" | "sharp" | undefined,
            label: config?.button?.text as "paypal" | "checkout" | "buynow" | "pay" | "installment" | "subscribe" | "donate" | undefined,
          }}
          createOrder={(data, actions) => {
            return actions.order.create({
              intent: 'CAPTURE',
              purchase_units: [
                {
                  amount: {
                    currency_code: currency,
                    value: String(amountToPay),
                  },
                },
              ],
              application_context: {
                shipping_preference: 'NO_SHIPPING',
              },
            });
          }}
          onApprove={async (data, actions) => {
            try {
              const details = await actions.order?.capture();
              const transactionId = details?.purchase_units?.[0]?.payments?.captures?.[0]?.id;
              handleSuccessPurchase(transactionId);
            } catch (e) {
              handleSuccessPurchase();
            }
          }}
          onError={() => {
            handleShowErrorPage(config?.messages?.paymentErrorMessage || "", true);
          }}
          onCancel={() => {
            handleShowErrorPage(config?.messages?.paymentErrorMessage || "", true);
          }}
        />
      </PaymentButtonBox>
    </PayPalScriptProvider>
  );
};

export default PayPal;
